import React from 'react';

import {
  Paragraph,
  SmallParagraph,
  Title,
} from '@accesa/react-core/build/composition/typography';
import { Link } from '@accesa/react-core/build/composition/link';
import { Button } from '@accesa/react-core/build/form/button';
import { Loader } from '@accesa/react-core/build/animations/loader';
import RatiodataLogo from '@accesa/react-core/build/layout/header/style/logo';

import S from './style/styled';
import LandingPageIcon from '../Icons/LandingPageIcon';
import { LoginProps } from './props';
import useConstLang from './lang';

export const LoginComponent: React.FC<LoginProps> = ({
  waitingForContentLoad,
  doLoginHandler,
}: LoginProps): React.ReactElement => {
  const T = useConstLang();
  const signInBody = T.signInBody.split('\n');

  return (
    <>
      <S.LoginWrapper>
        <S.LoginOverlay />
        <S.LoginBody>
          <section className="landingPageIcon">
            <LandingPageIcon />
          </section>

          <Title style={{ color: 'var(--charcoal)', margin: '16px 0' }} tag={'h1'}>{T.siteTitle}</Title>

          {signInBody.map((str, index) => (
            <section key={index}>
              <Paragraph style={{ color: 'var(--charcoal)' }}>
                {str}
              </Paragraph>
              {(index < signInBody.length - 1) && <br />}
            </section>
          ))}

          <S.LoginForm>
            <S.ActionsWrapper>
              {waitingForContentLoad && (
                <>
                  <Loader id={'login-loader'} color={'orange'} />
                </>
              )}
              <Button
                appearance={'primary'}
                text={T.loginButton}
                isFull={true}
                onClick={() => doLoginHandler()}
              />
            </S.ActionsWrapper>
          </S.LoginForm>

          <S.LoginFooter>
            <SmallParagraph style={{ color: 'var(--charcoal)' }}>{T.legend} <RatiodataLogo /></SmallParagraph>
          </S.LoginFooter>
        </S.LoginBody>
      </S.LoginWrapper>

      <S.LandingPageFooter>
        <Link
          size="large"
          primary
          alternative
          href="https://www.ratiodata.de/datenschutzerklaerung/"
          target="_blank"
          text="Datenschutzerklärung"
        />
        <Link
          size="large"
          primary
          alternative
          href="https://www.ratiodata.de/impressum/"
          target="_blank"
          text="Impressum" />
      </S.LandingPageFooter>
    </>
  );
};